import api from "./api";

export function getSupportPage(country_id) {
    return api.get(`/supportpage/${country_id}`);
}

export function createSupportPage(data) {
    return api.post("/supportpage", data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

export function updateSupportPage(country_id, data) {
    return api.put(`/support-page/${country_id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}
